<section [class]="getContainerClasses()">
  <div class="panel-body">
    <div class="widget-content">
      <ng-content select="[widget-content]"></ng-content>
    </div>
  </div>

  <ng-content select="[widget-footer]"></ng-content>

</section>
